import Translator from '../../../Shared/translator';
import v1_v2 from './v1_v2';
import v2_v3 from './v2_v3';
import v3_v4 from './v3_v4';
import v4_v5 from './v4_v5';
import v5_v6 from './v5_v6';
import v6_v7 from './v6_v7';

const translator: Translator = {
  ['v1_v2']: v1_v2,
  ['v2_v3']: v2_v3,
  ['v3_v4']: v3_v4,
  ['v4_v6']: v4_v5,
  ['v5_v6']: v5_v6,
  ['v6_v7']: v6_v7
};

export default translator;
